export default function mergeWorkspacePaginatedTasks(existing, incoming) {
  const existingTasks = existing.taskUserConnections || [];
  const incomingTasks = incoming.taskUserConnections || [];
  return {
    ...incoming,
    taskUserConnections: [...existingTasks, ...incomingTasks],
  };
}
